module.exports = __webpack_public_path__ + "static/media/star-on.60934937.svg";